module.exports = __webpack_public_path__ + "static/media/logo.6f777aad.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo.png
// module id = 72
// module chunks = 0